import { getDate } from 'common/utils/DateUtil'
import { isNil, round } from 'lodash'

const MONTH = {
    1: 'Jan',
    2: 'Fev',
    3: 'Mar',
    4: 'Avr',
    5: 'Mai',
    6: 'Jui',
    7: 'Jul',
    8: 'Aou',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
}

const formattingIssuesResolved = list => list.map(row => ({
    id: row.id,
    summary: row.summary,
    status: row.status,
    category: row.category,
    project: row.project,
    dateSubmitted: row.dateSubmitted,
    dateModified: row.dateModified,
    reporter: row.reporter,
    handler: row.handler,
    tempsPasse: row.tempsPasse,
    lot: row.lot,
}))

const formattingTableResolved = list => list.map(row => ({
    id: row.id,
    idIssue: { value: row.id },
    summary: { value: row.summary },
    status: { value: row.status },
    category: { value: row.category },
    project: { value: row.project },
    dateSubmitted: { value: getDate(row.dateSubmitted * 1000) },
    dateModified: { value: getDate(row.dateModified * 1000) },
    reporter: { value: row.reporter },
    handler: { value: row.handler },
    tempsPasse: { value: row.tempsPasse },
    lot: { value: row.lot },
}))

const headersResolvedTable = [{ key: 'idIssue', value: 'Id' }, { key: 'summary', value: 'Titre' },
    { key: 'status', value: 'Statut' }, { key: 'category', value: 'Catégorie' },
    { key: 'project', value: 'Projet' }, { key: 'dateSubmitted', value: 'Date de création' },
    { key: 'dateModified', value: 'Date de résolution' }, { key: 'reporter', value: 'Rapporteur' },
    { key: 'handler', value: 'Affecté à' }, { key: 'tempsPasse', value: 'Temps passé' }, { key: 'lot', value: 'Lot' }]

const headersResolvedExport = [...headersResolvedTable, { key: 'month', value: 'Mois' },
    { key: 'trimester', value: 'Trimestre' }, { key: 'semester', value: 'Semestre' }]

const formattingIssueCreated = rows => rows.map(row => ({
    id: row.id,
    summary: row.summary,
    status: row.status,
    category: row.category,
    project: row.project,
    dateSubmitted: row.dateSubmitted,
    reporter: row.reporter,
    handler: row.handler,
    lot: row.lot,
}))

const formattingTableCreated = rows => rows.map(row => ({
    id: row.id,
    idIssue: { value: row.id },
    summary: { value: row.summary },
    status: { value: row.status },
    category: { value: row.category },
    project: { value: row.project },
    dateSubmitted: { value: getDate(row.dateSubmitted * 1000) },
    reporter: { value: row.reporter },
    handler: { value: row.handler },
    lot: { value: row.lot },
}))

const headersCreatedTable = [{ key: 'idIssue', value: 'Id' }, { key: 'summary', value: 'Titre' },
    { key: 'status', value: 'Statut' }, { key: 'category', value: 'Catégorie' },
    { key: 'project', value: 'Projet' }, { key: 'dateSubmitted', value: 'Date de création' },
    { key: 'reporter', value: 'Rapporteur' }, { key: 'handler', value: 'Affecté à' }, { key: 'lot', value: 'Lot' }]

const headersCreatedExport = [...headersCreatedTable, { key: 'month', value: 'Mois' },
    { key: 'trimester', value: 'Trimestre' }, { key: 'semester', value: 'Semestre' }]


// Synthèse recalculée côté front à partir des lots VISIBLES (= non exclus manuellement), pour que
// les cartes du haut suivent les exclusions sans aller-retour serveur. Réplique exactement la logique
// du IssueController (champs termine / respecte / retardJours / echeance déjà fournis par ligne).
const computeSynthese = (lots) => {
    const termines = lots.filter(l => l.termine)
    const evaluables = termines.filter(l => !isNil(l.echeance))
    const nbRespectes = evaluables.filter(l => l.respecte).length
    const retards = lots.map(l => l.retardJours).filter(j => Number.isFinite(j) && j > 0)
    const sumRetards = retards.reduce((acc, j) => acc + j, 0)
    // Taux de retard = retard / durée du lot ; défini seulement pour les lots terminés à durée > 0.
    // Moyenne sur les lots terminés effectivement en retard (cohérent avec "Retard moyen").
    const tauxRetards = termines
        .map(l => {
            const duree = (Number.isFinite(l.dateFin) && Number.isFinite(l.dateDebut)) ? (l.dateFin - l.dateDebut) / 86400 : null
            return duree > 0 ? (l.retardJours ?? 0) / duree * 100 : null
        })
        .filter(t => Number.isFinite(t) && t > 0)
    const sumTauxRetards = tauxRetards.reduce((acc, t) => acc + t, 0)
    return {
        nbLots: lots.length,
        nbTermines: termines.length,
        nbEvaluables: evaluables.length,
        nbRespectes,
        tauxRespect: evaluables.length ? round((nbRespectes / evaluables.length) * 100, 1) : 0,
        nbEnRetard: retards.length,
        retardMoyen: retards.length ? round(sumRetards / retards.length, 1) : 0,
        nbTauxRetard: tauxRetards.length,
        tauxRetardMoyen: tauxRetards.length ? round(sumTauxRetards / tauxRetards.length, 1) : 0,
    }
}

export {
    MONTH, headersResolvedExport, headersResolvedTable,
    formattingTableResolved, formattingIssuesResolved, headersCreatedExport, headersCreatedTable,
    formattingTableCreated, formattingIssueCreated, computeSynthese,
}